import "./css/normalize.css"; //CSS reset
import "./css/site.css";

import React from "react";
import { Route, Routes } from "react-router-dom";

import { PAGE_ROUTES } from "../utils/stateTypes";
import Notification from "./general/Notification";
import ScrollToHash from "./general/ScrollToHash";
import TopNav from "./layout/TopNav";
import Footer from "./layout/Footer";
import Home from "./home/Home";
import NotFound from "./general/NotFound";

const App = () => {
  return (
    <React.Fragment>
      <a
        className={"skip-link"}
        href={"#main"}
      >
        Skip to main content
      </a>
      <ScrollToHash />
      <TopNav />
      <Notification />
      <main
        id={"main"}
        className={"site-main"}
      >
        <Routes>
          <Route
            path={PAGE_ROUTES.HOME}
            element={<Home />}
          />
          <Route
            path={"*"}
            element={<NotFound />}
          />
        </Routes>
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default App;
